import React from 'react';
import PropTypes from 'prop-types';

const ProductErrorMessage = ({title, message}) => (
  <div className="cartErrorWrapper">
    <div className="cart-alert topborder leader-0 nopadding">
      <div className="cart-alert-icon"></div>
      <div className="cart-alert-text">
        <h3>{title}</h3>
        <p>{message}</p>
      </div>
    </div>
  </div>
);

ProductErrorMessage.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default ProductErrorMessage;
